import React, { Component } from "react";
import usersApi from "./api/usersService";
import icons from "../../helpers/iconMenu";
import { getStaticText } from '../../lables/lablesService';
import Table from '../../components/table-data-component/table';
import Spinner from "../../components/spinner-component/Spinner";
import FlipCard from '../../components/flip-card-component/FlipCard';

import './users.scss'
import '../../scss/os-global.scss';

class Users extends Component {

  constructor(props) {
    super(props);

    this.DataService = usersApi;
    this.rows = [];
    this.page = 1;
    this.per_page = 10;
    this.all_pages = 0;
    this.order = { 'id': "DESC" };
    this.user_list = {};
    this.user_info = {};

    this.state = {
      'has_data': false,
      'show_popup': false,
    };
  }

  async changePage(page_number = 1) {
    this.page = page_number;
    await this.getDataList();
  }

  async changeOrder(new_order = {}) {
    this.order = new_order;
    await this.getDataList();
  }

  openPopUp(row_for_edit = {}) {
    this.user_list = {};
    Object.assign(
      this.user_list,
      row_for_edit
    );
    this.popupToggle(this.user_list.open_user_id);
  }

  async popupToggle(user_id) {
    const resp = await this.DataService.get_users_info(user_id)

    if (typeof (resp.rows) !== 'undefined') {
      resp.rows.map(row => {
        return this.user_info = row;
      })
    }

    this.setState({
      'show_popup': !this.state.show_popup
    });
  }

  async closePopUp() {
    this.setState({
      'show_popup': !this.state.show_popup
    });
    this.page = 1
    await this.getDataList()
  }

  async getDataList() {
    this.setState({ 'has_data': false });

    let list_response = await this.DataService.get_users_list({
      'page': this.page,
      'per_page': this.per_page,
      'order': this.order,
    });

    if (typeof (list_response.rows) !== 'undefined') {
      this.rows = list_response.rows;
      this.all_pages = list_response.all_pages;
    }

    this.setState({ 'has_data': true });
  }

  componentDidMount = async () => {
    await this.getDataList();
  }

  render() {
    let content = null;

    if (!this.state.has_data) {
      content = (
        <div className="col-lg-12 text-center">
          <Spinner />
        </div>
      );
    } else {
      content = (
        <>
          {this.state.show_popup ?
            <div className="overlay-popup">
              <FlipCard
                service={this.DataService}
                user_info={this.user_info}
                closeCard={this.closePopUp.bind(this)}
              />
            </div>
            : null
          }

          <div className="col-lg-12 pt-3">
            <Table
              currentOrder={this.order}
              changeOrderCallback={this.changeOrder.bind(this)}
              header={{
                'id': {
                  'label': getStaticText('u_th_id'),
                  'sortButton': true
                },
                'family_name': {
                  'label': getStaticText('u_th_second_name'),
                  'sortButton': true
                },
                'given_name': {
                  'label': getStaticText('u_th_first_name'),
                  'sortButton': true
                },
                'middle_name': {
                  'label': getStaticText('u_th_last_name'),
                  'sortButton': true
                },
                'active': {
                  'label': getStaticText('u_title_active'),
                  'sortButton': true
                },
                'action': {
                  'label': getStaticText('u_th_info'),
                  'sortButton': false
                }
              }}
              body={[
                (row) => { return row.id; },
                (row) => { return row.family_name; },
                (row) => { return row.given_name; },
                (row) => { return row.middle_name === "null" ? getStaticText('u_empty_middle_name') : row.middle_name },
                (row) => { return row.active ? getStaticText('u_active_yes') : getStaticText('u_active_no'); },
                (row) => {
                  return (
                    <i
                      className={icons.about_us_info}
                      onClick={this.openPopUp.bind(this, row)}
                      style={{ 'fontSize': '22px', 'color': "#248f8f" }}
                    />
                  );
                }
              ]}
              rows={this.rows}
              page={this.page}
              allPages={this.all_pages}
              changePageCallback={this.changePage.bind(this)}
              emptyRowsMessage={getStaticText('u_list_empty')}
            />
          </div>
        </>
      );
    }

    return (
      <div className="row">
        <div className="col-lg-12">
          <h2>{getStaticText('u_title')}</h2>
        </div>
        {content}
      </div>
    );
  }

}

export default Users;